import React from "react";
import { isStaggerEffectTransition } from "./erStaggerEffectTransitions";

const PAGE_GLITCH_OVERLAY_CSS = `
	@keyframes er-page-glitch-overlay-end {
		0%, 75% { opacity: 1; }
		100% { opacity: 0; visibility: hidden; }
	}
	@keyframes er-page-glitch-chroma-a {
		0% { transform: translate(-10px, 0) skewX(-2deg); opacity: 0.85; }
		18% { transform: translate(8px, -4px) skewX(1deg); opacity: 0.55; }
		36% { transform: translate(-6px, 3px); opacity: 0.7; }
		54% { transform: translate(5px, 1px); opacity: 0.35; }
		72% { transform: translate(-2px, 0); opacity: 0.15; }
		100% { transform: translate(0); opacity: 0; }
	}
	@keyframes er-page-glitch-chroma-b {
		0% { transform: translate(10px, 0) skewX(2deg); opacity: 0.85; }
		18% { transform: translate(-8px, 3px) skewX(-1deg); opacity: 0.55; }
		36% { transform: translate(6px, -2px); opacity: 0.7; }
		54% { transform: translate(-4px, -1px); opacity: 0.35; }
		72% { transform: translate(2px, 0); opacity: 0.15; }
		100% { transform: translate(0); opacity: 0; }
	}
	@keyframes er-page-glitch-scan-move {
		0% { transform: translateY(-100%); opacity: 0.9; }
		100% { transform: translateY(100%); opacity: 0; }
	}
	@keyframes er-page-glitch-bars {
		0%, 100% { opacity: 0; }
		8% { opacity: 0.9; transform: translateX(-6px); }
		16% { opacity: 0.7; transform: translateX(8px); }
		24% { opacity: 0.85; transform: translateX(-4px); }
		32% { opacity: 0.5; transform: translateX(5px); }
		40% { opacity: 0.75; transform: translateX(-2px); }
		48% { opacity: 0.4; transform: translateX(3px); }
		56% { opacity: 0.2; transform: translateX(0); }
	}
	@keyframes er-page-glitch-flash {
		0%, 100% { opacity: 0; }
		6% { opacity: 0.55; }
		12% { opacity: 0; }
		20% { opacity: 0.35; }
		28% { opacity: 0; }
	}
	@keyframes er-page-glitch-band-1 {
		0%, 100% { transform: translateX(0); }
		15% { transform: translateX(-12px); }
		30% { transform: translateX(9px); }
		45% { transform: translateX(-5px); }
	}
	@keyframes er-page-glitch-band-2 {
		0%, 100% { transform: translateX(0); }
		18% { transform: translateX(10px); }
		33% { transform: translateX(-11px); }
		48% { transform: translateX(4px); }
	}
	@keyframes er-page-glitch-band-3 {
		0%, 100% { transform: translateX(0); }
		12% { transform: translateX(8px); }
		27% { transform: translateX(-9px); }
		42% { transform: translateX(6px); }
	}
	.er-page-glitch-overlay {
		position: absolute;
		inset: 0;
		z-index: 800;
		pointer-events: none;
		border-radius: inherit;
		overflow: hidden;
		animation: er-page-glitch-overlay-end var(--er-glitch-dur, 0.5s) ease-out forwards;
		backdrop-filter: contrast(1.4) saturate(1.35) brightness(1.05);
	}
	.er-page-glitch-overlay__band {
		position: absolute;
		left: -12px;
		right: -12px;
		height: 22%;
		pointer-events: none;
		mix-blend-mode: screen;
		opacity: 0.85;
	}
	.er-page-glitch-overlay__band--1 {
		top: 8%;
		background: linear-gradient(90deg, rgba(255, 0, 200, 0.35), transparent 70%);
		animation: er-page-glitch-band-1 0.44s steps(5) forwards;
	}
	.er-page-glitch-overlay__band--2 {
		top: 38%;
		background: linear-gradient(270deg, rgba(0, 229, 255, 0.35), transparent 70%);
		animation: er-page-glitch-band-2 0.44s steps(5) forwards;
	}
	.er-page-glitch-overlay__band--3 {
		top: 68%;
		background: linear-gradient(90deg, rgba(255, 0, 200, 0.28), transparent 65%);
		animation: er-page-glitch-band-3 0.44s steps(5) forwards;
	}
	.er-page-glitch-overlay__chroma {
		position: absolute;
		inset: -6px;
		pointer-events: none;
		mix-blend-mode: screen;
	}
	.er-page-glitch-overlay__chroma--a {
		background: linear-gradient(90deg, rgba(255, 0, 200, 0.62), transparent 50%);
		animation: er-page-glitch-chroma-a 0.42s steps(6) forwards;
	}
	.er-page-glitch-overlay__chroma--b {
		background: linear-gradient(270deg, rgba(0, 229, 255, 0.62), transparent 50%);
		animation: er-page-glitch-chroma-b 0.42s steps(6) forwards;
	}
	.er-page-glitch-overlay__scan {
		position: absolute;
		inset: 0;
		background: repeating-linear-gradient(
			0deg,
			transparent 0,
			transparent 2px,
			rgba(0, 0, 0, 0.12) 2px,
			rgba(0, 0, 0, 0.12) 4px
		);
		opacity: 0.5;
		animation: er-page-glitch-scan-move 0.38s linear forwards;
		mix-blend-mode: multiply;
	}
	.er-page-glitch-overlay__bars {
		position: absolute;
		inset: 0;
		background: linear-gradient(
			180deg,
			transparent 0%,
			transparent 18%,
			rgba(255, 255, 255, 0.14) 18%,
			rgba(255, 255, 255, 0.14) 22%,
			transparent 22%,
			transparent 48%,
			rgba(0, 0, 0, 0.2) 48%,
			rgba(0, 0, 0, 0.2) 52%,
			transparent 52%,
			transparent 72%,
			rgba(255, 255, 255, 0.1) 72%,
			rgba(255, 255, 255, 0.1) 76%,
			transparent 76%
		);
		animation: er-page-glitch-bars 0.45s steps(4) forwards;
		mix-blend-mode: overlay;
	}
	.er-page-glitch-overlay__flash {
		position: absolute;
		inset: 0;
		background: #fff;
		animation: er-page-glitch-flash 0.45s steps(3) forwards;
		mix-blend-mode: soft-light;
	}
`;

export function getPageTransitionWrapperStyle(transitionType, durationMs) {
	const id = String(transitionType || "none");
	if (id === "none") return {};
	const sec = id === "glitch"
		? Math.max(0.28, (Number(durationMs) || 500) / 1000)
		: Math.max(0.15, (Number(durationMs) || 350) / 1000);
	if (id === "glitch") {
		return {
			opacity: 0,
			animation: `er-page-glitch-content ${sec}s ease-out both`,
		};
	}
	if (id === "comic" || id === "scatter" || id === "reveal" || isStaggerEffectTransition(id)) return {};
	if (id === "flashEnter" || id === "flashBoth" || id === "flashExit") return {};
	const initial =
		id === "slideLeft"
			? { opacity: 0, transform: "translateX(20%)" }
			: id === "slideRight"
				? { opacity: 0, transform: "translateX(-20%)" }
				: id === "slideUp"
					? { opacity: 0, transform: "translateY(20%)" }
					: id === "slideDown"
						? { opacity: 0, transform: "translateY(-20%)" }
						: id === "zoom"
							? { opacity: 0, transform: "scale(0.92)" }
							: { opacity: 0 };
	return {
		...initial,
		animation: `er-page-${id} ${sec}s ease-out both`,
	};
}

export default function EscapeRoomPageGlitchOverlay({ durationMs = 500, overlayKey }) {
	const sec = Math.max(0.28, (Number(durationMs) || 500) / 1000);
	return (
		<>
			<style>{PAGE_GLITCH_OVERLAY_CSS}</style>
			<div
				key={overlayKey || "glitch"}
				className="er-page-glitch-overlay"
				style={{ "--er-glitch-dur": `${sec}s` }}
				aria-hidden
			>
				<div className="er-page-glitch-overlay__band er-page-glitch-overlay__band--1" />
				<div className="er-page-glitch-overlay__band er-page-glitch-overlay__band--2" />
				<div className="er-page-glitch-overlay__band er-page-glitch-overlay__band--3" />
				<div className="er-page-glitch-overlay__chroma er-page-glitch-overlay__chroma--a" />
				<div className="er-page-glitch-overlay__chroma er-page-glitch-overlay__chroma--b" />
				<div className="er-page-glitch-overlay__scan" />
				<div className="er-page-glitch-overlay__bars" />
				<div className="er-page-glitch-overlay__flash" />
			</div>
		</>
	);
}
